import { Link } from 'react-router-dom';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
import { LINKS_EXTERNOS } from '../data/catalogoDestaque';

/** Página pública alinhada ao plano salas.lunins.org — pode ser servida também em subdomínio (CNAME → /salas). */
export default function Salas() {
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <div className="border-b border-lunins-border bg-hero-mesh">
          <div className="mx-auto max-w-3xl px-4 py-14 md:py-20">
            <p className="text-xs font-semibold uppercase tracking-widest text-lunins-accent">Bem-estar corporativo</p>
            <h1 className="mt-3 font-display text-3xl font-bold text-lunins-ink md:text-4xl">Salas de descompressão Lunins</h1>
            <p className="mt-4 text-lunins-muted leading-relaxed">
              Espaços pensados para pausas restauradoras no trabalho — com equipamentos Lunins e orientação da equipe.
              Em <strong className="text-lunins-ink/80">salas.lunins.org</strong> você pode apontar o mesmo conteúdo (Nginx:
              <code className="mx-1 rounded bg-lunins-sand px-1 text-xs">location = /</code> proxy para esta rota ou build
              estático).
            </p>
          </div>
        </div>
        <div className="mx-auto max-w-3xl space-y-8 px-4 py-12 md:py-16">
          <section className="rounded-2xl border border-lunins-border bg-lunins-surface/50 p-6 md:p-8">
            <h2 className="font-display text-xl font-bold text-lunins-ink">O que oferecemos</h2>
            <ul className="mt-4 space-y-3 text-sm text-lunins-muted">
              <li className="flex gap-2">
                <span className="text-lunins-accent">•</span>
                Projeto de sala com massageadores, cintas, esteiras e acessórios da linha Lunins.
              </li>
              <li className="flex gap-2">
                <span className="text-lunins-accent">•</span>
                Apresentação institucional para RH e liderança (materiais complementares em lunins.org).
              </li>
              <li className="flex gap-2">
                <span className="text-lunins-accent">•</span>
                Suporte e tutoriais para sua equipe aproveitar os equipamentos com segurança.
              </li>
            </ul>
          </section>
          <section className="flex flex-col gap-4 sm:flex-row">
            <a
              href={LINKS_EXTERNOS.luninsOrgSalas}
              target="_blank"
              rel="noreferrer"
              className="inline-flex flex-1 items-center justify-center rounded-full border border-lunins-accent/40 bg-lunins-accent/10 px-6 py-3 text-center text-sm font-semibold text-lunins-accent transition hover:bg-lunins-accent/20"
            >
              Conteúdo em lunins.org
            </a>
            <Link
              to="/loja"
              className="inline-flex flex-1 items-center justify-center rounded-full bg-lunins-ink px-6 py-3 text-center text-sm font-semibold text-lunins-cream transition hover:bg-lunins-ink-soft"
            >
              Ver loja oficial
            </Link>
          </section>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
